import { apiService } from '@/services/APIService';
import templatesService from './templates';
import questionsService from './questions';
import foldersService from './folders';
import answersService from './answers';
import journalService from './journal';
import secondChanceService from './second-chance';
import questionCategoriesService from './question-categories';

const PATH = '/polls';

export default {
  templates: templatesService,
  questions: questionsService,
  folders: foldersService,
  answers: answersService,
  journal: journalService,
  secondChance: secondChanceService,
  questionCategories: questionCategoriesService,

  // from CRUD

  getAll(params) {
    return apiService.get(PATH, params);
  },

  get(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },

  create(payload) {
    return apiService.post(PATH, payload);
  },

  update(id, payload) {
    return apiService.put(`${PATH}/${id}`, payload);
  },

  delete(id) {
    return apiService.delete(`${PATH}/${id}`);
  },

  deleteAll(payload) {
    return apiService.delete(PATH, payload);
  },

  // TEMPLATES
  getPollTemplates(params) {
    return apiService.get('/polls/templates', params);
  },

  showPollTemplate(id, params) {
    return apiService.get(`/polls/templates/${id}`, params);
  },

  createPollTemplate(params) {
    return apiService.post('/polls/templates/', params);
  },

  updatePollTemplate(id, params) {
    return apiService.put(`/polls/templates/${id}`, params);
  },

  deleteTemplate(id) {
    return apiService.delete(`/polls/templates/${id}`);
  },

  pollFolderAdd(id, params) {
    return apiService.post(`/poll-folders/${id}/add`, params);
  },

  pollFolderRemove(id, params) {
    return apiService.post(`/poll-folders/${id}/remove`, params);
  },

  // END templates

  getPollAnswers(id, stageId, params) {
    return apiService.post(`/polls/${id}/event-stage/${stageId}`, params);
  },

  sendAnswers(id, stageId, params) {
    return apiService.post(`/polls/${id}/event-stage/${stageId}/answers`, params);
  },

  syncEventStagePolls(id, params) {
    return apiService.post(`/event-stages/${id}/polls/`, params);
  },

  // RECOMENDATIONS
  getAllPollRecommedations(params) {
    return apiService.get('/polls/recommendations', params);
  },

  showPollRecommedations(id, params) {
    return apiService.get(`/polls/recommendations/${id}`, params);
  },

  updatePullRecommedations(id, params) {
    return apiService.put(`/polls/recommendations/${id}`, params);
  },

  createPollRecommedation(params) {
    return apiService.post('/polls/recommendations', params);
  },

  deletePollRecommedation(id, params) {
    return apiService.delete(`/polls/recommendations/${id}`, params);
  },

  // POLL settings

  showPollSettings(id, params) {
    return apiService.get(`/poll-settings/${id}`, params);
  },

  updatePollSettings(id, params) {
    return apiService.put(`/poll-settings/${id}`, params);
  },
  showPollListRights(params) {
    return apiService.get(`lists/poll-rights`, params);
  },
  getPollEventRights(params) {
    return apiService.get(`/poll-event-rights`, params);
  },
  getPollEventRightsCached(params) {
    return apiService.getCached(`/poll-event-rights`, params);
  },
  createPollEventRights(params) {
    return apiService.post(`/poll-event-rights`, params);
  },
  updatePollEventRights(id, params) {
    return apiService.put(`/poll-event-rights/${id}`, params);
  },
  removePollEventRights(id) {
    return apiService.delete(`/poll-event-rights/${id}`);
  },
  showAvailablePolls(id, params) {
    return apiService.get(`/events/${id}/available-polls`, params);
  },
  showPollsByStage(id, params) {
    return apiService.get(`/event-stages/${id}/polls`, params);
  },
  showSettingsByStage(stageId, pollId, params) {
    return apiService.get(`/event-stages/${stageId}/polls/${pollId}`, params);
  },
  createPollOnEventStage(stageId, pollId, payload) {
    return apiService.post(`/event-stages/${stageId}/polls/${pollId}`, payload);
  },
  updatePollOnEventStage(stageId, pollId, payload) {
    return apiService.put(`/event-stages/${stageId}/polls/${pollId}`, payload);
  },
  attachPollToEventStage(stageId, payload) {
    return apiService.post(`event-stages/${stageId}/polls`, payload);
  },
  detachPollFromEventStage(stageId, payload) {
    return apiService.post(`event-stages/${stageId}/detach-poll`, payload);
  },
  //  Question settings

  getPollQuestionSettings(params) {
    return apiService.get('/poll-questions-settings', params);
  },

  showPollQuestionSettings(id, params) {
    return apiService.get(`/poll-questions-settings/${id}`, params);
  },

  updatePollQuestionSettings(id, params) {
    return apiService.put(`/poll-questions-settings/${id}`, params);
  },
  getTestQuestions(params) {
    return apiService.get('/poll-questions/test', params);
  },
  getPollQuestions(params) {
    return apiService.get(`/poll-questions`, params);
  },
  getQuestion(id, params) {
    return apiService.get(`/poll-questions/${id}`, params);
  },
  getAudienceSettings(id, params) {
    return apiService.get(`/poll-event-stages/${id}/all-audience-is-set`, params);
  },
  setPollAudience(params) {
    return apiService.post('/poll-event-stages/set-selection', params);
  },
  getPollStageSettings(params) {
    return apiService.get('/poll-event-stages/settings', params);
  },
  setPollStageSettings(payload) {
    return apiService.post('/poll-event-stages/settings', payload);
  },
  updatePollStageSettings(id, payload) {
    return apiService.put(`/poll-event-stages/settings/${id}`, payload);
  },
  deletePollStageSettings(id) {
    return apiService.delete(`/poll-event-stages/settings/${id}`);
  },
  // Questions Sort Order
  updateQuestionsSortOrder(params) {
    return apiService.put(`/poll-questions/sort-order`, params);
  },
  // Question Images
  updatePollQuestionImages(id, params) {
    return apiService.post(`/poll-questions/${id}/images`, params);
  },

  getEventPolls(id, params) {
    return apiService.get(`events/${id}/polls`, params);
  },
  getEventPollsForSolve(id, params) {
    return apiService.get(`events/${id}/polls-for-solve`, params);
  },
  // POLL Hints
  getPollHints(id, params) {
    return apiService.get(`/polls/${id}/hints`, params);
  },
  createPollHint(id, params) {
    return apiService.post(`/polls/${id}/hints`, params);
  },
  updatePollHint(id, params) {
    return apiService.put(`/polls/${id}/hints/${params.id}`, params);
  },
  deletePollHint(id, params) {
    return apiService.delete(`/polls/${id}/hints/${params.id}`, params);
  },
  // Question categories
  getPollQuestionCategories(params) {
    return apiService.get('/poll-question-categories', params);
  },
  createPollQuestionCategory(params) {
    return apiService.post('/poll-question-categories', params);
  },
  updatePollQuestionCategory(id, params) {
    return apiService.put(`/poll-question-categories/${id}`, params);
  },
  deletePollQuestionCategory(id) {
    return apiService.delete(`/poll-question-categories/${id}`);
  },
};
